export function equipementReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_EQUIPEMENT":            
        case "UPDATE_EQUIPEMENT":
        case "EQUIPEMENT_LOAN_END":
            let list = Object.assign({}, state);
            list[payload.equipement_id] = payload
        
            return list
        case "NEW_EQUIPEMENT_LIST":            
            let list0 = Object.assign({}, state);
            list0 = Object.assign(list0, payload);
        
            return list0
        case "EQUIPEMENT_LOAN_START":
            let list2 = Object.assign({}, state);
            list2[payload.loan_equipement].equipement_available = false
            list2[payload.loan_equipement].equipement_status = "loan"
            list2[payload.loan_equipement].equipement_state_current = payload.equipement_state_start
            list2[payload.loan_equipement].equipement_remarks_current = payload.equipement_remarks_start  

            return list2

        // case "EQUIPEMENT_LOAN_END":
            // let list3 = Object.assign({}, state);
            // console.log({payload, equipID: payload.loan_equipement});

            // list3[payload.loan_equipement].equipement_available = true
            // list3[payload.loan_equipement].equipement_status = ""
            // list3[payload.loan_equipement].equipement_state_current = payload.equipement_state_end
            // list3[payload.loan_equipement].equipement_remarks_current = payload.equipement_remarks_end  

            // return list3
        case "DELETE_EQUIPEMENT":
            let list4 = Object.assign({}, state);
            
            delete list4[payload]
            return list4
        case "GET_EQUIPEMENTS":

            return payload
            
        default:
            return state;
    }
    
}